import React, { useEffect } from 'react';
import { useMatches } from 'react-router';
import { useAppContext } from '/@contexts/global-app-context';
import { UserState } from '../services/system/config-service/session-service';
import { CORE_ROUTES } from './core-routes';
import { useOnboardingNavigation } from './onboarding/hooks/use-onboarding-navigation';

export const NavActions: React.FC = () => {
    const { navService, sessionService } = useAppContext();
    const matches = useMatches();
    const currentAppRoute = matches.find(match => match.handle);
    const isLoggedIn = sessionService.isLoggedIn();
    const isUserExpired =
        isLoggedIn && sessionService.getUserState() === UserState.EXPIRED;

    useEffect(() => {
        // Exit out if navService isn't initialized yet.
        if (!navService || !navService.isInitialized) {
            return;
        }
        if (!isLoggedIn && navService.shouldShowDeepLinkPage()) {
            if (
                !matches.some(match =>
                    match.pathname.includes(CORE_ROUTES.Deeplink.path),
                )
            ) {
                navService.goToDeepLinkPage();
            }
        }
    }, [navService, currentAppRoute, isLoggedIn]);

    useEffect(() => {
        // Exit out if navService isn't initialized yet.
        if (!navService || !navService.isInitialized || !isLoggedIn) {
            return;
        }
        if (isUserExpired) {
            navService.goToPurchase();
        }
    }, [isLoggedIn, isUserExpired, navService]);

    useOnboardingNavigation();

    return null;
};
